import ProjectTeamSidebarWidgetComponent from './sidebar-widget.component'

const ProjectTeamSidebarWidgetModule = angular.module('cdbl.project-team.sidebar-widget', [

])
  .component('cdblProjectTeamSidebarWidget', ProjectTeamSidebarWidgetComponent)
  .name

export default ProjectTeamSidebarWidgetModule
